module.exports = __webpack_public_path__ + "assets/img/A_icon.ea4de464.png";